import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "takingUpService",
    "endOfService",
    "vehicleChanged",
    "addressSection",
    "vehicleSection",
    "startAtSection",
    "workTypeSection",
    "vehicleChangedSection",
    "mileageEndSection",
  ];

  connect() {
    this.update();
  }

  update() {
    const takingUp =
      this.hasTakingUpServiceTarget && this.takingUpServiceTarget.checked;
    const endOf = this.hasEndOfServiceTarget && this.endOfServiceTarget.checked;
    const vehicleChanged =
      this.hasVehicleChangedTarget && this.vehicleChangedTarget.checked;

    this.toggle("addressSection", takingUp || endOf);
    this.toggle("vehicleSection", takingUp || endOf || vehicleChanged);
    this.toggle("startAtSection", !endOf);
    this.toggle("workTypeSection", !endOf);
    this.toggle("vehicleChangedSection", !(takingUp || endOf));
    this.toggle("mileageEndSection", vehicleChanged);
  }

  toggle(targetName, visible) {
    const hasTarget = `has${targetName.charAt(0).toUpperCase()}${targetName.slice(1)}Target`;
    const target = `${targetName}Target`;
    if (this[hasTarget]) {
      this[target].classList.toggle("hidden", !visible);
    }
  }
}
